const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export async function apiRequest(path, method='GET', body=null, token=null){
  const headers = { 'Content-Type': 'application/json' };
  if(token) headers['Authorization'] = 'Bearer ' + token;
  const res = await fetch(API_BASE + path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null
  });

  let data;
  try {
    data = await res.json();
  } catch (err) {
    data = { message: 'An unexpected error occurred (non-JSON response)' };
  }

  if(!res.ok) {
    throw { ...data, message: data.message || `Error ${res.status}: ${res.statusText}` };
  }
  return data;
}
